import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "statusTranslator",
  standalone: false,
})
export class TranslateStatusPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case "REQUESTED": //REQUESTED
        return "REQUESTED";
      case "PRICE_PENDING": //PICKED-UP
        return "PICKED-UP";
      case "ACTIVE": //QUOTED
        return "QUOTED";
      case "ACCEPTED": //DEALT
      case "DONE":
        return "DEALT";
      case "CLIENT_REJECTED": // REJECTED
      case "SALES_REJECTED":
        return "REJECTED";
      case "TRADER_REJECTED": //DECLINED
        return "DECLINED";
      case "ABORTED": // ABORTED
        return "ABORTED";
      case "TIMED_OUT": // TIMED_OUT
        return "EXPIRED";
      case "CREDIT_PENDING": // Not on the UI
        return "CREDIT_PENDING";
      default:
        return "NAN";
    }
  }
}
